var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFolder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Add-Cotnainer-&-Device-&-Cluster",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Add-Container-Fixed-method-Week-popup",
    transform: "translate(-854.000000, -873.000000)",
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Change-password-Popup-",
    transform: "translate(739.000000, 286.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(27.000000, 577.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Save-button-Copy",
    transform: "translate(72.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Save-icon",
    transform: "translate(16.000000, 10.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "folder-open",
    transform: "translate(3.000000, 5.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.4545455,14.5454545 L1.81818182,14.5454545 C0.809090909,14.5454545 0,13.7272727 0,12.7272727 L0,1.81818182 C0,0.809090909 0.809090909,0 1.81818182,0 L7.27272727,0 L9.09090909,1.81818182 L15.4545455,1.81818182 C16.4586995,1.81818182 17.2727273,2.63220955 17.2727273,3.63636364 L17.2727273,3.63636364 L1.81818182,3.63636364 L1.81818182,12.7272727 L3.76363636,5.45454545 L19.2818182,5.45454545 L17.2090909,13.1818182 C17,13.9727273 16.2909091,14.5454545 15.4545455,14.5454545 Z",
    id: "Path"
  }))))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/folder.9244d49c.svg";
export { ForwardRef as ReactComponent };